<template>
  <ul class="mt-3 text-white cursor-pointer menu">
    <router-link
      v-if="(user.isAdmin && false) || user.isOwner"
      to="/estadisticas"
      tag="li"
      class="px-2 mb-2 text-xs font-medium rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
        <div class="">Escritorio</div>
      </div>
    </router-link>
    <div class="mb-2">
      <router-link
        exact-path
        v-if="user.isAdmin"
        to="/shipments"
        tag="li"
        class="px-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
      >
        <div class="flex items-center px-0 py-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              fill="#fff"
              d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
            />
          </svg>
          <div class="">Envíos</div>
        </div>
      </router-link>
      <router-link
        exact-path
        v-if="user.isAdmin"
        to="/scan"
        tag="li"
        class="px-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600 md:hidden"
      >
        <div class="flex items-center px-0 py-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            data-slot="icon"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
            />
          </svg>

          <div class="">Escanear QR</div>
        </div>
      </router-link>
      <!-- Crear 3 subitems -->
      <transition name="slide">
        <div>
          <router-link
            v-if="user.isAdmin && currentArea.includes('shipments')"
            to="/shipments/entregas-andreani"
            tag="li"
            class="px-2 text-xs font-normal bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0 py-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Estado Andreani</div>
            </div>
          </router-link>
          <router-link
            v-if="user.isAdmin && currentArea.includes('shipments')"
            to="/shipments/entregas-dhl"
            tag="li"
            class="px-2 text-xs font-normal bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0 py-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Estado DHL</div>
            </div>
          </router-link>
        </div>
      </transition>
    </div>
    <div class="mb-2">
      <router-link
        exact-path
        v-if="user.isAdmin"
        to="/retiros"
        tag="li"
        class="px-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
      >
        <div class="flex items-center px-0 py-2">
          <svg
            class="h-6 w-6"
            stroke="currentColor"
            viewBox="0 0 64 64"
            fill="none"
            stroke-width="2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M60.68 45.48C60.4589 44.9218 60.127 44.4142 59.7041 43.9879C59.2813 43.5617 58.7764 43.2256 58.22 43C57.6822 42.7723 57.1041 42.6549 56.52 42.6549C55.9359 42.6549 55.3578 42.7723 54.82 43L42.09 47.51C42.1336 47.2556 42.157 46.9981 42.16 46.74C42.16 45.6049 41.7091 44.5162 40.9064 43.7136C40.1038 42.9109 39.0151 42.46 37.88 42.46H34.58C31.6453 42.4574 28.7553 41.7401 26.16 40.37C23.2789 38.8464 20.0691 38.05 16.81 38.05H11.81V34.5C11.81 34.2348 11.7046 33.9804 11.5171 33.7929C11.3296 33.6054 11.0752 33.5 10.81 33.5H4C3.73478 33.5 3.48043 33.6054 3.29289 33.7929C3.10536 33.9804 3 34.2348 3 34.5V59C3 59.2652 3.10536 59.5196 3.29289 59.7071C3.48043 59.8946 3.73478 60 4 60H10.81C11.0752 60 11.3296 59.8946 11.5171 59.7071C11.7046 59.5196 11.81 59.2652 11.81 59V56.75C13.6051 56.8324 15.3795 57.1691 17.08 57.75L22.22 59.57C24.8546 60.4967 27.6272 60.9701 30.42 60.97H31.42C34.4138 60.8345 37.3582 60.1569 40.11 58.97L58.54 51.1C59.5302 50.5955 60.2976 49.741 60.6931 48.7024C61.0886 47.6638 61.0839 46.5153 60.68 45.48V45.48ZM9.81 58H5V35.5H9.81V58ZM57.73 49.32L39.36 57.17C36.8274 58.2604 34.1153 58.874 31.36 58.98C28.4717 59.1003 25.587 58.6693 22.86 57.71L17.74 55.9C15.8299 55.2299 13.8321 54.8425 11.81 54.75V40.05H16.81C19.7423 40.0465 22.6305 40.7643 25.22 42.14C28.1057 43.661 31.318 44.4572 34.58 44.46H37.88C38.1803 44.46 38.4776 44.5193 38.7548 44.6345C39.0321 44.7497 39.2839 44.9186 39.4958 45.1313C39.7076 45.3441 39.8753 45.5966 39.9893 45.8744C40.1033 46.1522 40.1613 46.4497 40.16 46.75C40.1617 47.0755 40.0919 47.3974 39.9554 47.6929C39.8188 47.9885 39.619 48.2503 39.37 48.46L37.69 49.05H26.78C26.5148 49.05 26.2604 49.1554 26.0729 49.3429C25.8854 49.5304 25.78 49.7848 25.78 50.05C25.78 50.3152 25.8854 50.5696 26.0729 50.7571C26.2604 50.9446 26.5148 51.05 26.78 51.05H37.88C38.02 51.05 55.56 44.89 55.56 44.89C55.8613 44.7587 56.1864 44.6909 56.515 44.6909C56.8436 44.6909 57.1687 44.7587 57.47 44.89C57.7752 45.0138 58.0521 45.1982 58.2841 45.4319C58.5161 45.6657 58.6984 45.9439 58.82 46.25C59.0445 46.8081 59.0577 47.4289 58.857 47.996C58.6563 48.563 58.2556 49.0374 57.73 49.33V49.32Z"
              fill="black"
            />
            <path
              d="M26.0801 31.88L42.8101 40.88C42.9547 40.957 43.1161 40.9973 43.2801 40.9973C43.444 40.9973 43.6054 40.957 43.7501 40.88L60.4701 31.88C60.6297 31.795 60.7634 31.6682 60.8567 31.5132C60.95 31.3583 60.9996 31.1809 61.0001 31V13C60.9996 12.8191 60.95 12.6417 60.8567 12.4867C60.7634 12.3318 60.6297 12.205 60.4701 12.12L43.7501 3.11999C43.6054 3.04295 43.444 3.00266 43.2801 3.00266C43.1161 3.00266 42.9547 3.04295 42.8101 3.11999L26.0801 12.12C25.9222 12.2063 25.7906 12.3337 25.6991 12.4885C25.6076 12.6434 25.5596 12.8201 25.5601 13V31C25.5596 31.1799 25.6076 31.3566 25.6991 31.5114C25.7906 31.6663 25.9222 31.7936 26.0801 31.88V31.88ZM27.5601 14.67L42.2801 22.6V38.33L27.5601 30.4V14.67ZM32.7501 10.8L46.8501 18.94L43.2801 20.86L28.6701 13L32.7501 10.8ZM38.0001 7.99999L52.1101 16.14L48.9501 17.84L34.8201 9.68999L38.0001 7.99999ZM50.1301 19.45L52.9001 18V21.3L52.1601 20.56C52.0436 20.4447 51.9007 20.3598 51.7437 20.3127C51.5868 20.2656 51.4207 20.2578 51.2601 20.29C51.1002 20.3236 50.9509 20.3958 50.8254 20.5004C50.6999 20.605 50.6019 20.7388 50.5401 20.89L50.1301 21.89V19.45ZM44.2801 38.33V22.6L48.1301 20.53V26.91C48.1328 27.1395 48.2143 27.361 48.361 27.5375C48.5078 27.714 48.7107 27.8346 48.9358 27.8792C49.161 27.9238 49.3946 27.8895 49.5975 27.7822C49.8003 27.675 49.9602 27.5011 50.0501 27.29L51.8101 23L53.2001 24.38C53.3404 24.5176 53.5183 24.6108 53.7113 24.6479C53.9044 24.685 54.1041 24.6644 54.2855 24.5886C54.4668 24.5129 54.6219 24.3853 54.7312 24.2219C54.8405 24.0585 54.8993 23.8666 54.9001 23.67V16.88L59.0001 14.67V30.4L44.2801 38.33ZM43.2801 5.13999L57.8901 13L54.1501 15L40.0501 6.87999L43.2801 5.13999Z"
              fill="black"
            />
          </svg>
          <div class="">Retiros</div>
        </div>
      </router-link>
      <!-- Crear 3 subitems -->
      <transition name="slide">
        <div>
          <router-link
            v-if="user.isAdmin && currentArea.includes('retiros')"
            to="/retiros"
            tag="li"
            class="px-2 text-xs font-normal bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0 py-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Entregas</div>
            </div>
          </router-link>
          <router-link
            v-if="user.isAdmin && currentArea.includes('retiros')"
            to="/retiros/pendientes"
            tag="li"
            class="px-2 text-xs font-normal bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0 py-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Pendientes</div>
            </div>
          </router-link>
        </div>
      </transition>
    </div>

    <router-link
      v-if="user.isAdmin && false"
      to="/autores"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
          />
        </svg>

        <div class="">Autores</div>
      </div>
    </router-link>
    <router-link
      v-if="user.isAdmin"
      to="/ventas"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
          />
        </svg>

        <div class="">Punto de venta</div>
      </div>
    </router-link>
    <div class="mb-2">
      <router-link
        v-if="user.isAdmin || allowed('staff')"
        exact-path
        to="/discounts/cupones"
        tag="li"
        class="px-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
      >
        <div class="flex items-center px-0 py-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
            />
          </svg>

          <div>Cupones</div>
        </div>
      </router-link>
      <transition name="slide">
        <div>
          <router-link
            to="/discounts/cupones"
            v-if="
              (user.isAdmin || allowed('staff')) &&
              currentArea.includes('discounts')
            "
            tag="li"
            class="px-2 text-xs py-2 font-normal bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Cupones</div>
            </div>
          </router-link>
          <router-link
            to="/discounts/regalos"
            v-if="
              (user.isAdmin || allowed('staff')) &&
              currentArea.includes('discounts')
            "
            tag="li"
            class="px-2 text-xs font-normal py-2 bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Regalos</div>
            </div>
          </router-link>
        </div>
      </transition>
    </div>

    <div class="mb-2">
      <router-link
        v-if="user.isAdmin || allowed('staff')"
        to="/products"
        tag="li"
        class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
      >
        <div class="flex items-center px-0 py-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
            />
          </svg>
          <div>Productos</div>
        </div>
      </router-link>

      <transition name="slide">
        <div>
          <router-link
            to="/products"
            v-if="
              (user.isAdmin || allowed('staff')) &&
              currentArea.includes('products')
            "
            tag="li"
            class="px-2 text-xs py-2 font-normal bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Listado</div>
            </div>
          </router-link>
          <router-link
            to="/products/orden"
            v-if="
              (user.isAdmin || allowed('staff')) &&
              currentArea.includes('products')
            "
            tag="li"
            class="px-2 text-xs font-normal py-2 bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Orden</div>
            </div>
          </router-link>
        </div>
      </transition>
    </div>

    <router-link
      v-if="user.isAdmin || allowed('staff')"
      to="/products/orden"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
    </router-link>
    <router-link
      v-if="
        user.isAdmin ||
        (user.permissions && user.permissions.includes('eventos'))
      "
      to="/eventos"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
          />
        </svg>

        <div>
          Eventos
          <span
            style="font-size: 0.5rem"
            class="p-1 bg-red-700 rounded text-white"
            >NUEVO</span
          >
        </div>
      </div>
    </router-link>
    <div class="mb-2">
      <router-link
        v-if="user.isAdmin || allowed('staff')"
        to="/stock"
        tag="li"
        class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
      >
        <div class="flex items-center px-0 py-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
            />
          </svg>

          <div>Stock</div>
        </div>
      </router-link>

      <transition name="slide">
        <div>
          <router-link
            to="/stock"
            v-if="
              (user.isAdmin || allowed('staff')) &&
              currentArea.includes('stock')
            "
            tag="li"
            class="px-2 text-xs py-2 font-normal bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Alta y baja</div>
            </div>
          </router-link>
          <router-link
            to="/stock/general"
            v-if="
              (user.isAdmin || allowed('staff')) &&
              currentArea.includes('stock')
            "
            tag="li"
            class="px-2 text-xs font-normal py-2 bg-opacity-25 rounded hover:bg-base-600 ml-3"
          >
            <div class="flex items-center px-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2 caret"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <div class="">Ver stock</div>
            </div>
          </router-link>
        </div>
      </transition>
    </div>
    <router-link
      v-if="user.isAdmin || allowed('staff')"
      to="/categories"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>
        <div>Categorias</div>
      </div>
    </router-link>

    <router-link
      v-if="user.isAdmin && false"
      to="/customers"
      tag="li"
      class="px-2 mb-2 text-xs font-medium text-gray-600 bg-opacity-25 rounded cursor-not-allowed hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <div>Clientes</div>
      </div>
    </router-link>
    <router-link
      v-if="user.isAdmin"
      to="/audios"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z"
          />
        </svg>

        <div>
          Audios
          <span
            style="font-size: 0.5rem"
            class="p-1 bg-orange-500 rounded text-white"
            >NUEVO</span
          >
        </div>
      </div>
    </router-link>
    <router-link
      v-if="user.isAdmin || user.isOwner"
      to="/orders"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <div>Pedidos</div>
      </div>
    </router-link>
    <!-- <router-link 
      v-if="user.isAdmin"
      to="/orders-old"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <div>Pedidos <span class="px-2 py-1 text-white bg-red-400 rounded text-xxs">Anterior</span></div>
      </div>
    </router-link> -->
    <router-link
      v-if="user.isAdmin"
      to="/estadisticas"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
        <div>Estadisticas</div>
      </div>
    </router-link>
    <router-link
      v-if="user.isAdmin"
      to="/settings"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
          />
        </svg>
        <div>Configuración</div>
      </div>
    </router-link>
    <router-link
      v-if="user.isAdmin || allowed('staff')"
      to="/shipping-zones"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
          />
        </svg>
        <div>Zonas de Envío</div>
      </div>
    </router-link>

    <router-link
      v-if="user.isAdmin"
      to="/bonos"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
        </svg>

        <div class="">Bonos Canelones</div>
      </div>
    </router-link>
    <router-link
      to="/login"
      tag="li"
      class="px-2 mb-2 text-xs font-medium bg-opacity-25 rounded hover:bg-base-600"
    >
      <div class="flex items-center px-0 py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          />
        </svg>
        <div>Salir</div>
      </div>
    </router-link>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      forceMenu: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    currentArea() {
      return this.$route.path.split("/")[1];
    },
    // menuOpen() {
    //   // Si la ruta contiene shipments
    //   if (this.currentArea.includes("shipments")) return "shipments";
    //   return false;
    // },
  },
  methods: {
    async logout() {
      await this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    allowed(permissions) {
      if (!this.user) return false;
      if (this.user.isAdmin) return true;
      if (this.user.permissions) {
        return this.user.permissions.some((permission) =>
          permissions.includes(permission)
        );
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.router-link-exact-active,
.router-link-exact-active svg {
  // Color Orsange
  color: #f6ad55;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.caret {
  margin-right: 0.5rem;
  transition: transform 0.3s ease;
  width: 0.75rem !important;
  height: 0.75rem !important;
}
</style>
